import { render, staticRenderFns } from "./BankData.vue?vue&type=template&id=020de96b&scoped=true&"
import script from "./BankData.vue?vue&type=script&lang=js&"
export * from "./BankData.vue?vue&type=script&lang=js&"
import style0 from "./BankData.vue?vue&type=style&index=0&id=020de96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020de96b",
  null
  
)

export default component.exports